__webpack_require__.p = "https://partnership-frontend-nextjs-prod.ackoassets.com/next_assets/166fbbb4d9ee651b67b6d660c89795d77d2c313f/_next/";